import React, { useEffect, useState } from "react";
import { postDQListaProcedimientoOtrosParticipantes, postDQProcedimiento, postGuardarCirujanosYCirugias, postInsertarOtrosParticipantesDQ, postOtrosParticipantesMedicos,  postProcedimientoVias, postTodosLosProcedimientoDX } from "../../../services/PaginaRuta";
import ModalListaDeSeleccionEspcialidadProcedimientoDQ from "./ModalListaDeSeleccionEspcialidadProcedimientoDQ";
import ModalListaDeSeleccionMaestroDeProcedimientoDQ from "./ModalListaDeSeleccionMaestroDeProcedimientoDQ";
import ModalListaDeSeleccionMedicosProcedimientoDQ from "./ModalListaDeSeleccionMedicosProcedimientoDQ";
import ModalOtrosParticipantesEspecilidadesDQ from "./ModalOtrosParticipantesEspecilidadesDQ";
import ModalOtrosParticipantesHonorariosDQ from "./ModalOtrosParticipantesHonorariosDQ";
import ModalOtrosParticipantesMedicosDQX from "./ModalOtrosParticipantesMedicosDQX";
import ModalSeleccionHonorariosProcedimientoDQ from "./ModalSeleccionHonorariosProcedimientoDQ";
import TablaOtrosParticipantesDX from "./TablaOtrosParticipantesDX";
import TablaProcedimientoDQX from "./TablaProcedimientoDQX";
import ModalValidarMedicoRepetido from "./ModalValidarMedicoRepetido";

const ModalProcedimientoDQX = ({item, setmodalOnDescripcionQuirurgica, setactualizarTablaProcedimientos,handleCancelClickListaProcedimientos}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [modalOnSeleccionMaestroProcedimiento, setmodalOnSeleccionMaestroProcedimiento]=useState(false)
  const [modalOnSeleccionMedicoEspecialista, setmodalOnSeleccionMedicoEspecialista]=useState(false)
  const [modalOnEspecialidadDelMedico, setmodalOnEspecialidadDelMedico]=useState(false)
  const [modalOnSeleccionHonorarios, setmodalOnSeleccionHonorarios]=useState(false)
  const [modalOnOtrosParticipantesMedicos, setmodalOnOtrosParticipantesMedicos]=useState(false)
  const [modalOnOtrosParticipantesEspecialidad, setmodalOnOtrosParticipantesEspecialidad]=useState(false)
  const [modalOnOtrosParticipantesHonorarios, setmodalOnOtrosParticipantesHonorarios]=useState(false)
  const [dataProcedimiento, setdataProcedimiento]=useState([])
  const [dataVias, setdataVias]=useState([])
  const [errorCantidad, setErrorCantidad]=useState('')
  const [errorRealizada, seterrorRealizada]=useState('')
  const [errorCodigoProcedimiento, seterrorCodigoProcedimiento]=useState('')
  const [errorCirujano, seterrorCirujano]=useState('')
  const [errorHonorario, seterrorHonorario]=useState('')
  const [errorHonorarioOtros, seterrorHonorarioOtros]=useState('')
  const [errorMedicoOtros, seterrorMedicoOtros]=useState('')
  const [isRealizada, setIsRealizada]=useState(false)
  const [todosProcedimientoTabla, settodosProcedimientoTabla]=useState([])
  const [isParticipo, setIsparticipo]=useState(false)
  const [participoUser, setparticipoUser]=useState('')
  const [dataOtrosParticipantes, setdataOtrosParticipantes]=useState([])
  const [actualizadata, setactualizadata]=useState([])
  const [cantidadAct, setcantidadAct]=useState(0)
  const [dataUser, setdataUser]=useState([])
  const [dataMedicoExistente, setdataMedicoExistente]=useState([])
  const [modalOnMedicoRepetido, setmodalOnMedicoRepetido]=useState(false)
  const [passDataMaestroProcedimiento, setpassDataMaestroProcedimiento]=useState({
    codigoMaestro:'',
    nombreMaestro:''
  })
  const [passDataMedicoEspecialista, setpassDataMedicoEspecialista]=useState({
    codigoMedigo:'',
    nombreMedico:'',
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })
  const [passDataEspecilidad, setpassDataEspecilidad]=useState({
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })
  const [passDataHonorarios, setpassDataHonorarios]=useState({
    codigoHonorario:'',
    nombreHonorario:''
  })
  const [passOtrosParticipantesMedicos,setpassOtrosParticipantesMedicos]=useState({
    codigoMedigo:'',
    nombreMedico:'',
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })
  const [passOtrosParticipantesEspecialidad, setpassOtrosParticipantesEspecialidad]=useState({
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })
  const [passOtrosParticipantesHonorarios, setpassOtrosParticipantesHonorarios]=useState({
    codigoHonorario:'',
    nombreHonorario:''
  })

  const handleCancelClick=()=>{
    setmodalOnDescripcionQuirurgica(false)
    handleCancelClickListaProcedimientos()
  }

  const passActualizarOtrosParticipantes=(data)=>{
    setactualizadata(data)
  }

  const passDataOtrosParticipantesHonorarios=(data)=>{
    setpassOtrosParticipantesHonorarios(data)
    //console.log(data,'honorariossss')
    seterrorHonorarioOtros('')
  }

  const childOnOtrosParticipantesHonorarios=()=>{
    setmodalOnOtrosParticipantesHonorarios(true)
  }

  const passDataOtrosParticipantesEspecialidades=(data)=>{
    setpassOtrosParticipantesEspecialidad(data)
    //console.log(data,'data medicos otros particpantes especialidades')
    setpassOtrosParticipantesMedicos({
      codigoMedigo:passOtrosParticipantesMedicos.codigoMedigo,
      nombreMedico:passOtrosParticipantesMedicos.nombreMedico,
      codigoEspecialidad:data.codigoEspecialidad,
      nombreEspecialidad:data.nombreEspecialidad
    })
  }

  const childOnOtrosParticipantesEspecialidades=()=>{
    setmodalOnOtrosParticipantesEspecialidad(true)
  }

  const passDataOtrosParticipantesMedicos=(data)=>{
    setpassOtrosParticipantesMedicos(data)
    seterrorMedicoOtros('')
    //console.log(data,'data medicos otros particpantes')
  }

  const childOnOtrosParticipantesMedicos=()=>{
    setmodalOnOtrosParticipantesMedicos(true)
  }

  const passDataHonorariosDX=(data)=>{
    setpassDataHonorarios(data)
    //console.log(data,'data honorarios')
    seterrorHonorario('')
  }

  const passDataEspecialidadM=(data)=>{
    setpassDataEspecilidad(data)
    //console.log(data,'data especialidad')
    setpassDataMedicoEspecialista({
      codigoMedigo:passDataMedicoEspecialista.codigoMedigo,
      nombreMedico:passDataMedicoEspecialista.nombreMedico,
      codigoEspecialidad:data.codigoEspecialidad,
      nombreEspecialidad:data.nombreEspecialidad
    })
  }

  const passDataMedico=(data)=>{
    //console.log(data,'data medicooo')
    setpassDataMedicoEspecialista(data)
    seterrorCirujano('')
  }

  const passDataMaestro=(data)=>{
    setpassDataMaestroProcedimiento(data)
    //console.log(data,'passsssssssss')
    seterrorCodigoProcedimiento('')
  }

  const handleOnclickSeleccionarHonorarios=()=>{
    setmodalOnSeleccionHonorarios(true)
  }

  const handleOnclickEspecialidadMedico=()=>{
    setmodalOnEspecialidadDelMedico(true)
  }

  const handleOnclickMedicosEspecialista=()=>{
    setmodalOnSeleccionMedicoEspecialista(true)
  }

  const handleOnclickMaestroProcedimiento=()=>{
    setmodalOnSeleccionMaestroProcedimiento(true)
  }

  const handleOnsubmitOtrosParticipantesGuardar=(e)=>{
    e.preventDefault()
    const guardar={
      PersCod: e.target.codigomedicootros.value,
      ProCirCod: dataProcedimiento.ProCirCod,
      ProMCDpto: usuarioInfo.Sede,
      ProEmpCod: usuarioInfo.Empresa,
      PersTip: e.target.codigohonorariootros.value,
      PersEst: participoUser,
      PersEsp: e.target.codigoespecialidadotros.value

    }
    //console.log(guardar,'guarar otroso participantes')
    if(errorHonorarioOtros=='' && errorMedicoOtros==''){
      //console.log(dataOtrosParticipantes,'data otros participantes')
      //console.log(e.target.codigomedicootros.value,'e.target.codigomedicootros.value')
      let validarMedicoExistente = dataOtrosParticipantes.some((userValidar)=> userValidar.PersCod === e.target.codigomedicootros.value)
      //console.log(validarMedicoExistente,'validarMedicoExistente')
      if(validarMedicoExistente){
        let medicoRepetido = dataOtrosParticipantes.find((userValidar)=> userValidar.PersCod === e.target.codigomedicootros.value)
        //console.log(medicoRepetido,'ENTRO')
        setdataMedicoExistente(medicoRepetido)
        setmodalOnMedicoRepetido(true)
      }else{
        postInsertarOtrosParticipantesDQ(guardar).then((res)=>{
          //console.log(res.data,'insertar otros particpantes')
          setactualizadata(guardar)
        })
      }
      
    }
    

  }

  const handleOnsubmitguardarCirujanos=(e)=>{
    e.preventDefault()
    const guardar={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod:dataProcedimiento.ProCirCod,
      CrgCod:e.target.codigoProcedimiento.value,
      CrgPrcCns:'1',
      CrgEst:'S',
      CrgCnt:e.target.cantidad.value,
      ViaCod: e.target.viaP.value,
      DesQx:'',
      MedCod: e.target.codigoCirujan.value,
      EspcCod: e.target.codEspe.value,
      CrgHnrCi:e.target.honoCodi.value,
      CRGPRCAUT:'N',
      CirFinCod:''
    }
    //setactualizadata(false)
    //console.log(guardar,'guraedando procedimiento antes')
    if(errorCantidad=='' && errorRealizada=='' && errorCodigoProcedimiento==''
    && errorCirujano=='' && errorHonorario==''){
      postGuardarCirujanosYCirugias(guardar).then((res)=>{
        //console.log(res.data,'gurardar despuess procedimiento')
        setactualizadata(guardar)
        setcantidadAct(0)
        setactualizarTablaProcedimientos(guardar)
      })
    }
  }

  useEffect(()=>{
    setdataUser(item)
    setcantidadAct(0)
    setparticipoUser('N')
    setErrorCantidad('La cantidad no es valida, verifique')
    seterrorRealizada('Se debe seleccionar el estado Realizada, para continuar')
    seterrorCodigoProcedimiento('Seleccionar un código procedimiento')
    seterrorCirujano('Seleccionar un cirujano')
    seterrorHonorario('Seleccionar un Honorario')
    seterrorHonorarioOtros('Seleccionar un honorario')
    seterrorMedicoOtros('Seleccionar un participante')
    setIsRealizada(false)
    setpassOtrosParticipantesHonorarios({
      codigoHonorario:'',
      nombreHonorario:''
    })
    setpassOtrosParticipantesMedicos({
      codigoMedigo:'',
      nombreMedico:'',
      codigoEspecialidad:'',
      nombreEspecialidad:''
    })
    setpassDataMedicoEspecialista({
      codigoMedigo:'',
      nombreMedico:'',
      codigoEspecialidad:'',
      nombreEspecialidad:''
    })
    setpassDataMaestroProcedimiento({
      codigoMaestro:'',
      nombreMaestro:''
    })
    setpassDataHonorarios({
      codigoHonorario:'',
      nombreHonorario:''
    })
    setIsparticipo(false)
    //console.log(item,'itemitemitemitem')
    const body={
      varProEmpCod: item.ProCEmp,
      varProMCDpto: item.ProMCDpto,
      varCodMed: item.ProCirCod
    }
    postDQProcedimiento(body).then((res)=>{
      //console.log(res.data,'dataaaaaaaaaaaaaaaa')
      setdataProcedimiento(res.data[0])
    })
    postProcedimientoVias().then((res)=>{
      //console.log(res.data,'viasss')
      setdataVias(res.data)
    })
    const bodyConsultar={
      varProEmpCod: item.ProCEmp,
      varProMCDpto: item.ProMCDpto,
      varProCirCod: item.ProCirCod
    }
    //console.log(bodyConsultar,'bodyConsultar')
    postTodosLosProcedimientoDX(bodyConsultar).then((res)=>{
      //console.log(res.data,'data de todos los pprrocedimiento')
      settodosProcedimientoTabla(res.data)
    })
    postOtrosParticipantesMedicos(bodyConsultar).then((res)=>{
      //console.log(res.data,'otros participantes')
      //setdataOtrosParticipantes(res.data)
    })
    postDQListaProcedimientoOtrosParticipantes(bodyConsultar).then((res)=>{
      //console.log(res.data,'data ultimo otros participantes')
      setdataOtrosParticipantes(res.data)
    })
  },[actualizadata])

  useEffect(()=>{
    
  },[])

  const handleOnchangeCantidad=(e)=>{
    setcantidadAct(e.target.value)
    if(e.target.value){
      setErrorCantidad('')
    }else{
      setErrorCantidad('La cantidad no es valida, verifique')
    }
  }
  const handleOnchangeRealizada=()=>{
    setIsRealizada(!isRealizada)
    if(!isRealizada){
      seterrorRealizada('')
    }else{
      seterrorRealizada('Se debe seleccionar el estado Realizada, para continuar')
    }
  }

  const handleOnchangeParticipo=(e)=>{
    setIsparticipo(!isParticipo)
    if(e.target.value){
      setparticipoUser('S')

    }else{
      setparticipoUser('N')
    }
    //console.log(participoUser,'partipopopopopo')
  }

  
  return (
    <>
    <div>
      <div className="flex-auto overflow-y-auto relative ">
        <div className="flex flex-row p-2  text-left">
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              N° Cirugía
            </label>
            <input
              defaultValue={dataProcedimiento.ProCirCod}
              disabled={true}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Número Documento 
            </label>
            <input
              defaultValue={dataProcedimiento.MPCedu}
              disabled={true}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPCedu}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Tipo Documento
            </label>
            <input
              disabled={true}
              defaultValue={dataProcedimiento.MPTDoc}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPTDoc}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Nombre del Paciente
            </label>
            <input
              disabled={true}
              defaultValue={dataProcedimiento.MPNOMC}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPNOMC}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div className="flex-auto overflow-y-auto relative px-2">
        <div className="flex flex-row py-2  text-left">
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Fecha
            </label>
            <input
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              defaultValue={dataProcedimiento.ProFec? dataProcedimiento.ProFec.split(' ')[0]:null}
              disabled={true}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Hora Inicio
            </label>
            <input
              type="text"
              disabled={true}
              //defaultValue={dataProcedimiento.MPCedu}
              defaultValue={dataProcedimiento.ProHorI}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Hora Final
            </label>
            <input
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPTDoc}
              disabled={true}
              defaultValue={dataProcedimiento.ProHorF}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Quirofano
            </label>
            <input
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPNOMC}
              disabled={true}
              defaultValue={dataProcedimiento.ProNcons}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div className="bg-[#9e56fe] mt-3">
      <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
        Cirugías y Cirujanos
      </label>
      </div>
      <form onSubmit={handleOnsubmitguardarCirujanos}>
      <div className="flex-auto overflow-y-auto relative p-2">
        <div className="flex flex-row py-1  text-left">
          <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo
            </label>
            <input
              defaultValue={passDataMaestroProcedimiento.codigoMaestro}
              type="text"
              autoComplete="off"
              onFocus={handleOnclickMaestroProcedimiento}
              name='codigoProcedimiento'
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorCodigoProcedimiento}
      </label>
          </div>
          <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Procedimiento
            </label>
            <input
              type="text"
              disabled={true}
              defaultValue={passDataMaestroProcedimiento.nombreMaestro}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Cantidad
            </label>
            <input
              onChange={handleOnchangeCantidad}
              value={cantidadAct}
              autoComplete="off"
              type="number"
              name="cantidad"
              //disabled={true}
              //defaultValue={dataProcedimiento.MPTDoc}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorCantidad}
                    </label>
          </div>
        </div>
      </div>
      <div className="flex-auto overflow-y-auto relative p-2">
        <div className="flex flex-row  text-left">
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Cirujano
            </label>
            <input
              type="text"
              autoComplete="off"
              name="codigoCirujan"
              onFocus={handleOnclickMedicosEspecialista}
              //disabled={true}
              defaultValue={passDataMedicoEspecialista.codigoMedigo}
              className="form-control block w-full px-1 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorCirujano}
      </label>
          </div>

          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Cirujano
            </label>
            <input
              type="text"
              disabled={true}
              defaultValue={passDataMedicoEspecialista.nombreMedico}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Especialidad
            </label>
            <input
              type="text"
              //disabled={true}
              name="codEspe"
              onFocus={handleOnclickEspecialidadMedico}
              defaultValue={passDataMedicoEspecialista.codigoEspecialidad}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Especialidad
            </label>
            <input
              type="text"
              //disabled={true}
              defaultValue={passDataMedicoEspecialista.nombreEspecialidad}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          
        </div>
      </div>
      <div className="flex-auto overflow-y-auto relative p-2">
        <div className="flex flex-row   text-left">
        <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Via
            </label>
            <select
              name="viaP"
              className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              aria-label="Default select example"
            >
              {
                dataVias.map((item)=>(
                  <option value={item.ViaCod} key={item.ViaCod}>{item.ViaDsc}</option>
                ))
              }
              
            </select>
          </div>
          <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Honorario
            </label>
            <input
              name="honoCodi"
              onFocus={handleOnclickSeleccionarHonorarios}
              autoComplete='off'
              defaultValue={passDataHonorarios.codigoHonorario}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorHonorario}
      </label>
          </div>
          <div className="w-1/3  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Honorario
            </label>
            <input
              type="text"
              disabled={true}
              defaultValue={passDataHonorarios.nombreHonorario}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
        </div>
      </div>

      <div className="flex-auto overflow-y-auto relative px-4">
        <div className="flex flex-row py-2  text-left">
          <div className="w-1/2 px-4">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium">
              Realizada?
            </label>
            <input
              onChange={handleOnchangeRealizada}
              checked={isRealizada}
              className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
              type="checkbox"
              name="valoracionPreanestesica"
              id="flexCheckDefault"
              //checked={reqValoracionPreanestesica}
              //onChange={handleOnchangeReqValoracionPreanestesica}
            />
            
            <div className="inline-block px-8 w-1/2">
              <button
                type="submit"
                //onClick={handleClickDataCirugia}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar
              </button>
            </div>
          </div>
          
        </div>
      </div>
      <div className="text-left px-6">
      <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorRealizada}
      </label>
      </div>
      </form>

      <div className="">
        <div className="flex flex-col">
          <div className="overflow-x-auto ">
            <div className="py-4 inline-block min-w-full ">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className="">
                    <tr>
                      <th></th>
                    <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Cd. Prod
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Procedimiento
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Realizada?
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Cant.
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Vía
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Codi. Cirujano
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Nombre Cirujano
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Codi. Espec.
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Especialidad
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Codi. Honorario
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-6 py-2"
                      >
                        Descripción
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      todosProcedimientoTabla.map((item,index)=>(
                        <TablaProcedimientoDQX key={index} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes} dataUser={dataUser}/>
                      ))
                    }
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#9e56fe] mt-3">
      <label className="form-label inline-block mb-2 text-white font-medium text-center text-2xl">
        Otros Participantes
      </label>
      </div>
      <form onSubmit={handleOnsubmitOtrosParticipantesGuardar}>
      <div className="flex-auto overflow-y-auto relative p-2">
        <div className="flex flex-row py-2  text-left">
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Médico
            </label>
            <input
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              name="codigomedicootros"
              defaultValue={passOtrosParticipantesMedicos.codigoMedigo}
              autoComplete="off"
              onFocus={childOnOtrosParticipantesMedicos}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorMedicoOtros}
            </label>
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Participante
            </label>
            <input
              type="text"
              disabled={true}
              defaultValue={passOtrosParticipantesMedicos.nombreMedico}
              //disabled={true}
              //defaultValue={dataProcedimiento.MPCedu}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Especialidad
            </label>
            <input
              type="text"
              //disabled={true}
              name="codigoespecialidadotros"
              onFocus={childOnOtrosParticipantesEspecialidades}
              autoComplete='off'
              defaultValue={passOtrosParticipantesMedicos.codigoEspecialidad}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Especialidad
            </label>
            <input
              type="text"
              disabled={true}
              defaultValue={passOtrosParticipantesMedicos.nombreEspecialidad}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
          {/* <div className="w-1/4  px-4 ">
            <label className="form-label block mb-2 text-gray-900 font-medium pt-6"></label>
            <button
              type="submit"
              //onClick={handleClickDataCirugia}
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Agregar
            </button>
          </div> */}
        </div>
      </div>
      <div className="flex-auto overflow-y-auto relative p-2">
        <div className="flex flex-row py-2  text-left">
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Codigo Honorario
            </label>
            <input
              name="codigohonorariootros"
              defaultValue={passOtrosParticipantesHonorarios.codigoHonorario}
              onFocus={childOnOtrosParticipantesHonorarios}
              //onChange={handleOnchangehonorariosotros}
              type="text"
              //disabled={true}
              //defaultValue={dataProcedimiento.ProCirCod}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
              readOnly
            />
            <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                      {errorHonorarioOtros}
            </label>
          </div>
          <div className="w-1/4  px-1 ">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
              Honorario
            </label>
            <input
               defaultValue={passOtrosParticipantesHonorarios.nombreHonorario}
              type="text"
              disabled={true}
              //defaultValue={dataProcedimiento.MPCedu}
              className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
              id="exampleFormControlInput1"
              placeholder=""
            />
          </div>
        </div>
      </div>
      
      <div className="flex-auto overflow-y-auto relative px-4">
        <div className="flex flex-row py-2  text-left">
          <div className="w-1/2 px-1">
            <label className="form-label inline-block mb-2 text-gray-900 font-medium">
              Participó?
            </label>
            <input
              //value={isParticipo}
              checked={isParticipo}
              onChange={handleOnchangeParticipo}
              className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
              type="checkbox"
              name="participo"
              id="flexCheckDefault"
              //checked={reqValoracionPreanestesica}
              //onChange={handleOnchangeReqValoracionPreanestesica}
            />
            <div className="inline-block px-8 w-1/2">
              <button
                type="submit"
                //onClick={handleClickDataCirugia}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
      </form>
      <div className="flex flex-col">
        <div className="overflow-x-auto ">
          <div className="py-4 inline-block min-w-full">
            <div className="overflow-hidden">
              <table className="min-w-full text-center bg-gray-200">
                <thead className="">
                  <tr>
                    <th></th>
                  <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Código
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Nombre
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Tipo
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Tipos Honorario
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Participó
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Código Especialidad
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-2"
                    >
                      Especialidad
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    dataOtrosParticipantes.map((item,index)=>(
                      <TablaOtrosParticipantesDX key={index} item={item} passActualizarOtrosParticipantes={passActualizarOtrosParticipantes}/>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
        <button type="button"
              onClick={handleCancelClick}
              className="inline-block px-3 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal">
              Cerrar
              </button>
        {/* <button
          type="submit"
          //onClick={handleClickDataCirugia}
          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
        >
          Guardar
        </button> */}
      </div>
    </div>
    {modalOnSeleccionMaestroProcedimiento? <ModalListaDeSeleccionMaestroDeProcedimientoDQ setmodalOnSeleccionMaestroProcedimiento={setmodalOnSeleccionMaestroProcedimiento} passDataMaestro={passDataMaestro}/>:null}
    {modalOnSeleccionMedicoEspecialista? <ModalListaDeSeleccionMedicosProcedimientoDQ setmodalOnSeleccionMedicoEspecialista={setmodalOnSeleccionMedicoEspecialista} passDataMedico={passDataMedico}/>:null}
    {modalOnEspecialidadDelMedico? <ModalListaDeSeleccionEspcialidadProcedimientoDQ setmodalOnEspecialidadDelMedico={setmodalOnEspecialidadDelMedico} passDataMedicoEspecialista={passDataMedicoEspecialista} passDataEspecialidadM={passDataEspecialidadM}/>:null}
    {modalOnSeleccionHonorarios? <ModalSeleccionHonorariosProcedimientoDQ setmodalOnSeleccionHonorarios={setmodalOnSeleccionHonorarios} passDataHonorariosDX={passDataHonorariosDX}/>:null}
    {modalOnOtrosParticipantesMedicos?<ModalOtrosParticipantesMedicosDQX setmodalOnOtrosParticipantesMedicos={setmodalOnOtrosParticipantesMedicos} passDataOtrosParticipantesMedicos={passDataOtrosParticipantesMedicos}/>:null}
    {modalOnOtrosParticipantesEspecialidad?<ModalOtrosParticipantesEspecilidadesDQ setmodalOnOtrosParticipantesEspecialidad={setmodalOnOtrosParticipantesEspecialidad} passOtrosParticipantesMedicos={passOtrosParticipantesMedicos} passDataOtrosParticipantesEspecialidades={passDataOtrosParticipantesEspecialidades}/>:null}
    {modalOnOtrosParticipantesHonorarios?<ModalOtrosParticipantesHonorariosDQ setmodalOnOtrosParticipantesHonorarios={setmodalOnOtrosParticipantesHonorarios} passDataOtrosParticipantesHonorarios={passDataOtrosParticipantesHonorarios}/>:null}
    {modalOnMedicoRepetido? <ModalValidarMedicoRepetido setmodalOnMedicoRepetido={setmodalOnMedicoRepetido} dataMedicoExistente={dataMedicoExistente}/>:null}
    </>
  );
};

export default ModalProcedimientoDQX;
